import { Outlet } from '@solidjs/router';
import Header from '../components/Header';

const Layout = () => (
  <div>
    <Header />
    <Outlet />
  </div>
);

export default Layout;
